import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styleListData from "./ListTaxDeclarationData.module.css";

import MainContent from "../../../layouts/maincontent/MainContent";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
// import TermsAndConditionsModal from "../../../components/UnifiedTaxDeclaration/termsConditionsModal/TermsAndConditionsModal";
// import Modal from "react-modal";

import SelectElement from "../../../shared/form/SelectElement";
import InputElement from "../../../shared/form/InputElement";
import { getDeclerations } from "../../../adapters/apis/UnifiedTaxDeclaration/list";
import { getDeclerationListFilterAllLookups } from "../../../adapters/apis/lookups/lookups";
import Moment from "moment";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import { DatePickerFormatedWithLimit } from "../../../shared/form/DatePickerFormated";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
import walletAdd from "../../../assets/img/wallet-add.svg";

import { useLocation } from "react-router-dom";

function DeclarationListData() {
  // Modal.setAppElement("body");

  const [declerationTypes, setDeclerationTypes] = useState([]);
  const [declerationList, setDeclerationList] = useState([]);
  const [declerationLength, setDeclerationLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startFrom, setStartFrom] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [declerationStatusTypes, setDeclerationStatusTypes] = useState([]);
  const [isUserCanCreateDeclaration, setIsUserCanCreateDeclaration] =
    useState(true);
  // const [showModal, setShowModal] = useState(false);
  const [links, setLinks] = useState(null);

  // const limit = 1;

  const [limit, setLimit] = useState(10);

  const initialFilters = {
    per_page: limit,
    declaration_number: "",
    declaration_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  };

  const [filters, setFilters] = useState({
    per_page: limit,
    declaration_number: "",
    declaration_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate({ state: null });
    }, 5000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const [filtersErrors, setFiltersErrors] = useState({
    declaration_number: "",
    declaration_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const [success, setSuccess] = useState("");
  const [error, setError] = useState(null);

  const changeDataFormat = (filters, newLimit, isFirstLoad = false) => {
    const data = {
      declaration_number: filters?.declaration_number,
      declaration_type_id: filters?.declaration_type_id,
      from_date: filters?.from_date
        ? Moment(filters?.from_date).format("yyyy-MM-DD")
        : "",
      to_date: filters?.to_date
        ? Moment(filters?.to_date).format("yyyy-MM-DD")
        : "",
      status: filters?.status,
    };

    if (!isFirstLoad) {
      data.per_page = newLimit || limit;
    }

    return data;
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit); // Update
    setCurrentPage(1); // Reset to first
    callback(1, newLimit); // Fetch data for page 1
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url;
        if (location.pathname.includes("list-data")) {
          url =
            "api/declaration-system/declaration-lookups/list-filter-all-lookups";
        } else {
          url =
            "api/declaration-system/declaration-lookups/declaration-debt-acc-payment";
        }

        const res = await getDeclerationListFilterAllLookups(url);
        setDeclerationTypes(res?.data?.data?.declaration_types);
        setDeclerationStatusTypes(res?.data?.data?.declaration_status);
      } catch (error) {
        // This will catch 429 and any other HTTP errors
        console.error("API error:", error);
        if (error.response?.status === 429) {
          console.warn("Too many requests. Please slow down.");
        }
      }
    };

    fetchData();
  }, [location?.pathname]);

  useEffect(() => {
    setIsLoading(true);

    getDeclerations(
      currentPage,
      changeDataFormat(filters, limit, currentPage === 1), // true on first load
      location?.pathname?.includes("list-data")
        ? "api/declaration-system/declarations"
        : "api/declaration-system/declarations/settlement-of-debts-with-the-taxpayers-knowledge",
    )
      .then((res) => {
        setDeclerationLength(res?.data?.meta?.total);
        setDeclerationList(res?.data?.data);
        setCurrentPage(res?.data?.meta?.current_page);
        setStartFrom(res?.data?.meta?.from);
        setLinks(res?.data?.links);
        setIsUserCanCreateDeclaration(res?.data?.can_create_declaration);
        if (res?.data?.data?.length === 0) {
          setError("لا توجد إقرارات متاحة");
        }
        setIsLoading(false);
      })
      .catch(() => {
        setError("لا توجد إقرارات متاحة");
      });
  }, [location?.pathname]);

  function callback(active, limit) {
    try {
      setIsLoading(true);
      setCurrentPage(active);
      getDeclerations(
        active,
        changeDataFormat(filters, limit),
        location?.pathname?.includes("list-data")
          ? "api/declaration-system/declarations"
          : "api/declaration-system/declarations/settlement-of-debts-with-the-taxpayers-knowledge",
      ).then((res) => {
        setDeclerationLength(res?.data?.meta?.total);
        setDeclerationList(res?.data?.data);
        setStartFrom(res?.data?.meta?.from);
        setLinks(res?.data?.links);

        if (res?.data?.data?.length === 0) {
          setError("لا توجد بيانات متاحة");
        }
        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  }

  const handleFromDateChange = (parentCompenent, compenent, key, value) => {
    // If both from_date and to_date have values, clear to_date
    if (filters.from_date && filters.to_date) {
      setFilters((prev) => ({
        ...prev,
        to_date: "",
      }));
    }

    // Update the from_date field
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      to_date: "",
    }));
  };

  const data = declerationList?.map((element, index) => {
    return (
      <tr key={element.id}>
        <td data-label="رقم الإقرار">{element?.declaration_number || ""}</td>
        <td data-label="نوع الإقرار">{element?.declaration_type_text || ""}</td>
        <td data-label="تاريخ إنشاء الإقرار">{element?.creation_date || ""}</td>
        <td data-label="تاريخ تقديم الإقرار">
          {element?.submittion_date || ""}
        </td>
        <td data-label="تاريخ تحديث الإقرار">{element?.update_date || ""}</td>
        <td data-label="صفة مقدم الإقرار">{element?.submitter_type || ""}</td>
        <td data-label="اسم المكلف بأداء الضريبة">{element?.taxpayer || ""}</td>
        <td data-label="حالة الإقرار">
          <span
            style={{
              backgroundColor:
                parseInt(element?.status_id) == 1
                  ? "#CFCFCF"
                  : parseInt(element?.status_id) == 2
                    ? "#E6FFE6"
                    : parseInt(element?.status_id) == 3
                      ? "#E3F5FF"
                      : parseInt(element?.status_id) == 4
                        ? "#FCFFC5"
                        : "#CFCFCF",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {element?.status_text || ""}
          </span>
        </td>
        {location?.pathname?.includes("list-data") && (
          <td data-label="تفاصيل">
            <Link
              to={"/tax-declaration/details/" + element?.id}
              className={styleListData["btn-file"]}
              id="dispute_info_icon"
            >
              <img src={disputeInfo} className="img-fluid" />
            </Link>
          </td>
        )}

        <td data-label="المدفوعات تحت حساب المديونية">
          {parseInt(element?.status_id) !== 1 ? (
            <Link
              to={
                `${location?.pathname?.includes("list-data") ? "/tax-declaration/payment-under-account/list/" : "/payment-account-debt/list/"}` +
                element?.id
              }
              className={styleListData["btn-file"]}
              id="wallet_icon"
            >
              <img src={walletAdd} className="img-fluid w-8 h-8" />
            </Link>
          ) : (
            ""
          )}
        </td>
      </tr>
    );
  });

  const appealTypeOptions = declerationTypes?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const declarationStatusOptions = declerationStatusTypes?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const search = () => {
    try {
      // setFlashMessage(false); // Clear the flash message
      setIsLoading(true);
      setCurrentPage(1);
      const formattedFilters = changeDataFormat(filters);
      // Call API with filters
      getDeclerations(
        1,
        formattedFilters,
        location?.pathname?.includes("list-data")
          ? "api/declaration-system/declarations"
          : "api/declaration-system/declarations/settlement-of-debts-with-the-taxpayers-knowledge",
      ).then((res) => {
        setDeclerationLength(res?.data?.meta?.total);
        setDeclerationList(res?.data?.data);
        setCurrentPage(res?.data?.meta?.current_page);
        setStartFrom(res?.data?.meta?.from);
        setLinks(res?.data?.links);
        if (res?.data?.data?.length === 0) {
          setError("لا توجد بيانات متاحة");
        }
        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  };

  const handleClearFilter = () => {
    try {
      setFilters(initialFilters);
      setCurrentPage(1);
      setIsLoading(true);
      getDeclerations(
        1,
        initialFilters,
        location?.pathname?.includes("list-data")
          ? "api/declaration-system/declarations"
          : "api/declaration-system/declarations/settlement-of-debts-with-the-taxpayers-knowledge",
      ).then((res) => {
        setDeclerationLength(res?.data?.meta?.total);
        setDeclerationList(res?.data?.data);
        setCurrentPage(res?.data?.meta?.current_page);
        setStartFrom(res?.data?.meta?.from);
        setLinks(res?.data?.links);
        if (res?.data?.data?.length === 0) {
          setError("لا توجد إقرارات متاحة");
        }

        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد إقرارات متاحة");
    }
  };

  function changeFilters(parentCompenent, compenent, key, value) {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <section className={`${styleListData.listData}`}>
            <div className="container pt-4">
              <div className={styleListData.box}>
                <div className={`${styleListData["box-header"]}`}>
                  <div className={`${styleListData["box-header"]}`}>
                    <button
                      className={`${styleListData["btn-arrow"]} ms-3`}
                      onClick={() => navigate(`/`)}
                    >
                      <i className="fa-solid fa-arrow-right mt-1"></i>
                    </button>
                    <h3 className={`${styleListData["box-title"]} mb-0`}>
                      {location?.pathname?.includes("list-data")
                        ? "طلبات الإقرار"
                        : "سداد مديونيات بعلم المكلف"}
                    </h3>
                  </div>
                  {location?.pathname?.includes("list-data") && (
                    <div className={styleListData["btns-header"]}>
                      <button
                        className={` ${
                          !isUserCanCreateDeclaration
                            ? styleListData["btn-disabled"]
                            : styleListData["btns-header-order"]
                        } `}
                        id="add_declaration_button"
                        onClick={() =>
                          navigate("/tax-declaration/submission-guide")
                        }
                      >
                        تقديم الإقرار
                      </button>
                    </div>
                  )}
                </div>
                {location?.state?.message && (
                  <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                    <h3 className="fs-5">{location?.state?.message} </h3>
                  </div>
                )}

                <div className={`${styleListData["box-body"]}  mt-3`}>
                  <div className={`${styleListData["box-body-content"]}`}>
                    <div className="row align-items-center px-md-4">
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <InputElement
                          name="declaration_number"
                          mb4="mb-4"
                          labelHtmlFor="declaration_number"
                          labelClassName={`${styleListData["form-label"]} form-label`}
                          labelText="رقم الإقرار"
                          inputType="text"
                          inputClassName="form-control"
                          inputID="declaration_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.declaration_number}
                          onChange={changeFilters}
                          pText={filtersErrors.declaration_number}
                          maxLength="255"
                          placeholder="رقم الإقرار"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="declaration_type_id"
                          labelClassName={`  form-label ${styleListData["form-label"]}`}
                          labelText="نوع الإقرار"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="declaration_type_id"
                          name="declaration_type_id"
                          options={appealTypeOptions}
                          default="نوع الإقرار"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.declaration_type_id}
                          onChange={changeFilters}
                          pText={filtersErrors.declaration_type_id}
                          style={{ color: "#32A8ED" }}
                          placeholderText="نوع الإقرار"
                        />
                      </div>

                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="from_date"
                          name_datepicker="from_date"
                          mb4="mb-4"
                          labelHtmlFor="from_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="تاريخ تقديم إقرار من"
                          inputType="datePicker"
                          max={Moment().subtract(500, "years")}
                          minDate={Moment("2026-01-01", "YYYY-MM-DD").toDate()}
                          inputClassName="form-control"
                          inputID="to_dfrom_dateate"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.from_date}
                          value={filters.from_date}
                          placeholderText="تاريخ تقديم إقرار من"
                          onChange={handleFromDateChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="to_date"
                          name_datepicker="to_date"
                          mb4="mb-4"
                          labelHtmlFor="to_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="تاريخ تقديم إقرار إلى"
                          inputType="datePicker"
                          // max={Moment().subtract(500, "years")}
                          minDate={
                            filters.from_date ||
                            Moment("2026-01-01", "YYYY-MM-DD").toDate()
                          }
                          inputClassName={`${styleListData["form-control"]} form-control`}
                          inputID="to_date"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.to_date}
                          value={filters.to_date}
                          valueDate={filters.to_date}
                          onChange={changeFilters}
                          placeholderText="تاريخ تقديم إقرار إلى"
                        />
                      </div>

                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="status"
                          labelClassName={`  form-label  ${styleListData["form-label"]}`}
                          labelText="حالة الإقرار"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="status"
                          name="status"
                          options={declarationStatusOptions}
                          default="حالة الإقرار"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.status}
                          onChange={changeFilters}
                          pText={filtersErrors.status}
                          placeholderText="حالة الإقرار"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end p-3">
                      <button
                        className={styleListData["btns-search"]}
                        onClick={search}
                        id="declaration_search_button"
                      >
                        بحث
                      </button>
                      <button
                        className={styleListData["btns-clear"]}
                        onClick={handleClearFilter}
                        id="declaration_clear_button"
                      >
                        إعادة
                      </button>
                    </div>
                  </div>
                  <div
                    className={`${styleListData["table-responsive"]} table-responsive`}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">رقم الإقرار</th>
                          <th scope="col">نوع الإقرار</th>
                          <th scope="col">تاريخ إنشاء الإقرار</th>
                          <th scope="col">تاريخ تقديم الإقرار</th>
                          <th scope="col">تاريخ تحديث الإقرار</th>
                          <th scope="col">صفة مقدم الإقرار</th>
                          <th scope="col">اسم المكلف بأداء الضريبة</th>
                          <th scope="col">حالة الإقرار</th>

                          {location?.pathname?.includes("list-data") && (
                            <th scope="col">تفاصيل</th>
                          )}
                          <th scope="col">
                            {location?.pathname?.includes("list-data")
                              ? "المدفوعات تحت الحساب"
                              : "المدفوعات تحت حساب المديونية"}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length > 0 ? (
                          data
                        ) : (
                          <tr>
                            <td colSpan={6} className="h5 text-center">
                              {error}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <PaginationTax
                    limit={limit}
                    count={declerationLength}
                    active={currentPage}
                    callback={callback}
                    handleLimitChange={handleLimitChange}
                    links={links}
                  />

                  {/* <TermsAndConditionsModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                  /> */}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </MainContent>
  );
}

export default DeclarationListData;
